import * as R from 'ramda';
// theme
import Theme from '../theme';
// helpers
import { ifElse } from './helpers';
//////////////////////////////////////////////////

const getTheme = (path, orValue) => R.pathOr(orValue || '', R.split('.', path), Theme);

const getThemeByCond = (condValue, path1, path2) => getTheme(
  ifElse(condValue, path1, path2),
);

const getThemeColor = (
  key = '',
  defaultValue = '#930000',
) => R.pathOr(R.or(defaultValue, ''), R.split('.', key), Theme);

const isThemeSecondVersion = (version) => R.equals(version, 2);

export {
  getTheme,
  getThemeColor,
  getThemeByCond,
  isThemeSecondVersion,
};
